/** PostgreSQL bigint IDs arrive as decimal strings; never coerce them to Number. */
export function accountIdentity(value: unknown): string | null {
  if (typeof value === "number") return Number.isSafeInteger(value) && value > 0 ? String(value) : null;
  return typeof value === "string" && /^[1-9]\d*$/.test(value) ? value : null;
}
